import OrganizationSelectPage from "@/features/session/pages/OrganizationSelect";

const OrganizationSelect = () => {
  return <OrganizationSelectPage />;
};

export default OrganizationSelect;
